export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6926.2474538e.jpg";